import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

export const notes: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    { fullWidth: true, controls: [{ type: 'field', field: 'notes' }] },
];
